import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { createStyles, Grid, GridProps } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => createStyles({
	root: {
		width: '100%',
		backgroundColor: theme.palette.common.white,
		alignItems: 'center',
		justifyContent: 'flex-start',
		flexDirection: 'row',
		padding: theme.spacing(2, 2, 1),
	},
}));

const AlertTitle: React.FC<GridProps> = ({ children, className, ...props }) => {
	const classes = useStyles();

	return (
		<Grid
			container
			className={classNames(classes.root, className)}
			{...props}
		>
			{children}
		</Grid>
	);
};

export default AlertTitle;
